const reducer = state => ({
  ...state,
  error: null,
  pending: false,
});

export default reducer;
